import * as yup from 'yup';
import { configure } from "vee-validate";
import { Directive } from 'vue';
import Cleave from 'cleave.js';

function initValidation() {
    // Validation localization
    yup.setLocale({
        // use constant translation keys for messages without values
        mixed: {
            default: "validation.invalid",
            required: "validation.required",
        },
        string: {
            email: "validation.email",
        },
        number: {
            min: ({ min }) => ({ key: "validation.min", values: [ min ] }),
            max: ({ max }) => ({ key: "validation.max", values: [ max ] }),
            positive: "validation.positive",
        },
    });

    yup.addMethod<yup.StringSchema>(yup.string, "currency", function (this: any, errorMessage: any) {
        return this.test("text-currency", errorMessage, function (this: any, value: string) {
            const { path, createError } = this;
            let isValid = false;

            if (value) {
                value = value.replace(/[^0-9.]/g, '');
                const amt = parseFloat(value.replace(/[^0-9.]/g, ''));
                if (!isNaN(amt) && amt >= 0) { isValid = true }
            }

            return (isValid || createError({ path, message: errorMessage || 'validation.currency' }));
        });
    });

    configure({
        validateOnBlur: true, // controls if `blur` events should trigger validation with `handleChange` handler
        validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
        validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
        validateOnModelUpdate: false, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
    });
}

const cleave: Directive = {
    mounted: (el, binding) => {
        el.cleave = new Cleave(el, binding.value || {})
    },
    updated: (el) => {
        const event = new Event('input', {bubbles: true});
        setTimeout(function () {
            el.value = el.cleave.properties.result
            el.dispatchEvent(event)
        }, 100);
    }
}

export { initValidation, cleave }